import React, { RefObject, FC } from 'react';
import { BBCommonProps } from 'types/story';
import { DISABLED_ANSWER_ATTR } from 'common/constants';
import cn from 'classnames';
import css from './Answer.scss';

export interface AnswerBodyProps extends BBCommonProps {
	isDisabled: boolean;
	onClickCapture: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => Promise<void>) | undefined;
}

const AnswerBody: FC<AnswerBodyProps> = props => {
	const editableProps = props.isEditableMode ? { ...props.editableModeProps?.nodeProps } : null;

	return (
		<div
			{...props.uiConfig.nodeProps}
			{...props.stateAttrs}
			{...props.eventListeners}
			// Capture phase is used to prevent any events at child nodes. Nothing should interfere an Answer logic
			onClickCapture={props.onClickCapture}
			{...editableProps}
			{...{ [DISABLED_ANSWER_ATTR]: props.isDisabled }}
			className={cn(css.answer, props.uiConfig.nodeProps.className, editableProps?.className)}
			ref={props.containerRef as RefObject<HTMLDivElement>}
		>
			{props.children}
		</div>
	);
};

export default AnswerBody;
